import { routes } from '../../core/routes';
import { mapSVG, overviewSVG } from '../../core/svg';
import AltLogo from '../../images/SideBar/logo-alt.png';
import NavItem from '../NavItem/NavItem';
import MonitoredHousesWidget from '../Widgets/MonitoredHouses/MonitoredHouses';
import './SideBar.scss';
import { useTranslation } from "react-i18next";

export default function SideBar() {
	//TRANSLATION INIT
	const { t } = useTranslation();

	return (
		<div className='Sidebar'>
			<div className='Sidebar__logo'>
				<img src={AltLogo} alt='Sexto Sentido Logo' />
			</div>
			<div className='Sidebar__navigation'>
				{(sessionStorage.getItem('access-type')?.toLocaleLowerCase() ?? "").indexOf(t("userKey")) === -1 && (
					<NavItem link={routes.dashboard.url} name={routes.dashboard.name} icon={overviewSVG} />
				)}
				<NavItem link={routes.map.url} name={routes.map.name} icon={mapSVG} />
			</div>
			<div className='Sidebar__houses'>
				<MonitoredHousesWidget />
			</div>
		</div>
	);
}